/*-----------------------------------------------------------------
- Dashboard routes
-----------------------------------------------------------------*/
const prefix: string = 'dashboard';

const routes = [
    {
        path     : `${prefix}`,
        name     : prefix,
        component: () => import('@/modules/dashboard/views/Dashboard.vue'),
        meta     : {
            guest: false,
        },

        children: [
            {
                path     : 'profile',
                name     : `${prefix}-profile`,
                component: () => import('@/modules/dashboard/views/Profile.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'profile/edit/:id?',
                name     : `${prefix}-profile-edit`,
                component: () => import('@/modules/dashboard/views/Profile.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'orders',
                name     : `${prefix}-orders`,
                component: () => import('@/modules/dashboard/views/Orders.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'orders/details/:id',
                name     : `${prefix}-order-details`,
                component: () => import('@/modules/dashboard/views/Orders.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'transactions',
                name     : `${prefix}-transactions`,
                component: () => import('@/modules/dashboard/views/Transactions.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'wishlist',
                name     : `${prefix}-wishlist`,
                component: () => import('@/modules/dashboard/views/Wishlist.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'charge-wallet',
                name     : `${prefix}-charge-wallet`,
                component: () => import('@/modules/dashboard/views/ChargeWallet.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'change-password',
                name     : `${prefix}-change-password`,
                component: () => import('@/modules/dashboard/views/ChangePassword.vue'),
                meta     : {
                    guest: false,
                },
            },
            {
                path     : 'addresses',
                name     : `${prefix}-addresses`,
                component: () => import('@/modules/dashboard/views/Addresses.vue'),
                meta     : {
                    guest: false,
                },
            },
        ],
    },
];

export default routes;
